// removed by extract-text-webpack-plugin
module.exports = {"cf-pro-account-edit":"style__cf-pro-account-edit___6_kkC"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Account/style.css
// module id = 177
// module chunks = 1